import {
  PanTool,
  ZoomTool,
  WindowLevelTool,
  LengthTool,
  AngleTool,
  PlanarFreehandROITool,
} from '@cornerstonejs/tools';
import { SPECTRAL_DOPPLER_TOOL_NAMES } from '@/features/study-detail/Viewer/tools/SpectralDoppler';
import styles from './ToolHint.module.css';

interface ToolHintProps {
  activeTool: string | undefined;
}

const TOOL_HINTS: Record<string, { gesture: string; label: string }> = {
  [PanTool.toolName]: {
    gesture: 'Click and drag',
    label: 'to pan the image',
  },
  [ZoomTool.toolName]: {
    gesture: 'Click and drag',
    label: 'to zoom',
  },
  [WindowLevelTool.toolName]: {
    gesture: 'Click and drag',
    label: 'to adjust window / level',
  },
  [LengthTool.toolName]: {
    gesture: 'Click two points',
    label: 'to measure length',
  },
  [AngleTool.toolName]: {
    gesture: 'Click three points',
    label: 'to measure an angle',
  },
  [PlanarFreehandROITool.toolName]: {
    gesture: 'Click and drag',
    label: 'to trace an area',
  },
  [SPECTRAL_DOPPLER_TOOL_NAMES.PROBE]: {
    gesture: 'Click',
    label: 'to measure velocity at a point',
  },
  [SPECTRAL_DOPPLER_TOOL_NAMES.SEGMENT]: {
    gesture: 'Click and drag',
    label: 'to measure a segment',
  },
  [SPECTRAL_DOPPLER_TOOL_NAMES.VTI]: {
    gesture: 'Click and drag',
    label: 'to trace the envelope',
  },
};

export function ToolHint({ activeTool }: ToolHintProps) {
  if (!activeTool) return null;
  const hint = TOOL_HINTS[activeTool];
  if (!hint) return null;
  return (
    <div className={styles.toolHint} role="status" aria-live="polite">
      <span className={styles.gesture}>{hint.gesture}</span>
      <span>{hint.label}</span>
    </div>
  );
}
